import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// FD INTEREST VERIFICATION
// Legacy: /AccountsApproval/VerifyFDInterest (+ VerifyFDInterestGrid / VerifyFDInterestView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — FD interest credits pending at this role's level.
export const getVerificationFDInterest = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationFDInterest`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail: interest, bank payment, deductions and MOID.
export const getFDInterestByTransNo = async (transactionNo) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetFDInterestbyTransno`, { params: { Transactionno: transactionNo }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Capital cost center / DCA / Sub DCA the interest deduction is booked against (spGetFDInterestDcaSdca).
export const getFDIntDeductionData = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetFDIntDeductionData`, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Reject (spApproveFDInterest — success literal "Submitted").
export const approveFDInterest = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApproveFDInterest`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
